import { normalizeEmptyParagraphs } from 'app/main/composeMessage/tiptapEditor/TiptapUtils'
import { removeDoNotTranslateStyle } from 'commons/form'
import { compose, lensProp, map, over, path, pathOr } from 'ramda'

const getMediaForSubmit = path(['media', 'submit'])

export const mapToApi = (formModel) => (translations) => {
  return {
    type: 1, // Always general notification
    priority: 1, // Always low priority
    entityType: 1, // Always send to all subscribers
    translations: map(
      over(
        lensProp('body'),
        compose(normalizeEmptyParagraphs, removeDoNotTranslateStyle),
      ),
      translations,
    ),
    voucherId: pathOr(null, ['voucher', 'id'], formModel),
    media: getMediaForSubmit(formModel),
  }
}
